import { css } from '@microsoft/fast-element';
import { fillColor, foregroundOnPrimaryRest, neutralForegroundRest, neutralInputFillActive, neutralInputFillHover, neutralInputFillRest, neutralStrokeActive, neutralStrokeHover, neutralStrokeRest, focusStrokeOuter, getToken } from '../../design-tokens';
import { heightNumber } from '../size';

export const baseRadioStyles = css`
    :host {
        font-size: ${getToken('typography-control-font-size')};
        line-height: ${getToken('typography-control-line-height')};
    }

    .control {
        --control-size: calc((${heightNumber} / 2 + ${getToken('space-design-unit')}) * 1px);
        position: relative;
        min-width: var(--control-size);
        min-height: var(--control-size);
        width: var(--control-size);
        height: var(--control-size);
        box-sizing: border-box;
        border-radius: 999px;
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${neutralStrokeRest};
        background: ${neutralInputFillRest};
        outline: none;
        cursor: pointer;
    }

    .label {
        font-family: ${getToken('typography-font-family')};
        color: currentColor;
        padding-inline-start: calc(${getToken('space-design-unit')} * 2px + 2px);
        cursor: pointer;
    }

    .label__hidden {
        display: none;
        visibility: hidden;
    }

    slot[name="checked-indicator"] {
        border-radius: 999px;
        display: flex;
        margin: auto;
        width: 16px;
        height: 100%;
        fill: ${foregroundOnPrimaryRest};
        opacity: 0;
        pointer-events: none;
    }

    :host(:not([disabled])) .control:hover {
        background: ${neutralInputFillHover};
        border-color: ${neutralStrokeHover};
    }

    :host(:not([disabled])) .control:active {
        background: ${neutralInputFillActive};
        border-color: ${neutralStrokeActive};
    }

    :host(:focus-visible) .control {
        box-shadow: 0 0 0 2px ${fillColor}, 0 0 0 4px ${focusStrokeOuter};
        border-color: ${getToken('color-neutral-focus')};
    }

    :host([aria-checked=true]) .control {
        background: ${getToken('color-primary-base')};
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${getToken('color-primary-base')};
    }

    :host([aria-checked=true]:not([disabled])) .control:hover {
        background: ${getToken('color-primary-hover')};
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${getToken('color-primary-hover')};
    }

    :host([aria-checked=true]:not([disabled])) .control:active {
        background: ${getToken('color-primary-active')};
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${getToken('color-primary-active')};
    }

    :host([aria-checked=true]:focus-visible:not([disabled])) .control {
        box-shadow: 0 0 0 2px ${fillColor}, 0 0 0 4px ${focusStrokeOuter};
        border-color: transparent;
    }

    :host(.disabled) .label,
    :host(.readonly) .label,
    :host(.readonly) .control,
    :host(.disabled) .control {
        cursor: not-allowed;
    }

    :host([aria-checked=true]) slot[name="checked-indicator"] {
        opacity: 1;
    }

    :host(.disabled) {
        opacity: ${getToken('color-disabled-opacity')};
    }
`;
